(function(){
    // Helper: remove `disabled` from all Update buttons
    function enableUpdateButtons() {
      document.querySelectorAll('.cart-actions__update').forEach(function(btn){
        btn.removeAttribute('disabled');
      });
    }
  
    // Initialise custom plus/minus quantity buttons for each quantity input
    function initQtyButtons(){
      document.querySelectorAll('.quantity.product__quantity').forEach(function(wrapper){
        var input = wrapper.querySelector('input[type="number"]');
        if (!input) return; // Skip if no input found

        // Prevent re-initialisation: only add buttons if not already added
        if (wrapper.querySelector('.product__minus')) return;
  
        // Create minus button
        var btnDec = document.createElement('button');
        btnDec.type = 'button';
        btnDec.className = 'product__minus';
        btnDec.textContent = '−';
  
        // Create plus button
        var btnInc = document.createElement('button');
        btnInc.type = 'button';
        btnInc.className = 'product__plus';
        btnInc.textContent = '+';
  
        // Insert the buttons before and after the input
        wrapper.insertBefore(btnDec, input);
        wrapper.insertBefore(btnInc, input.nextSibling);
  
        // Decrease quantity on minus click
        btnDec.addEventListener('click', function(){
          var step = parseFloat(input.step)||1,
              min  = parseFloat(input.min)||0,
              val  = parseFloat(input.value)||0;
          if (val>min) {
            input.value=(val-step).toFixed(0);
            input.dispatchEvent(new Event('change')); // Trigger change event
          }
        });

        // Increase quantity on plus click
        btnInc.addEventListener('click', function(){
          var step = parseFloat(input.step)||1,
              max  = parseFloat(input.max),
              val  = parseFloat(input.value)||0;
          if (isNaN(max)||val<max) {
            input.value=(val+step).toFixed(0);
            input.dispatchEvent(new Event('change')); // Trigger change event
          }
        });
      });
    }
  
    // Enable the Update button when a quantity is changed manually or by button
    function bindUpdateEnabler(){
      document.body.addEventListener('change', function(e){
        if ( e.target.matches('.quantity.product__quantity input[type="number"]') ) {
          enableUpdateButtons();
        }
      });

      // Detect clicks on plus or minus buttons
      document.body.addEventListener('click', function(e){
        if ( e.target.matches('.quantity.product__quantity .product__plus, .quantity.product__quantity .product__minus') ) {
          setTimeout(enableUpdateButtons, 0);
        }
      });
    }
  
    // On DOM ready: set up everything
    document.addEventListener('DOMContentLoaded', function(){
      initQtyButtons();
      bindUpdateEnabler();
    });
  
    // Re-initialise quantity buttons after WooCommerce AJAX fragment events
    ['updated_cart_totals','updated_wc_div','wc_fragments_refreshed'].forEach(function(evt){
      document.body.addEventListener(evt, initQtyButtons);
    });
  
    // Re-initialise after any jQuery AJAX completes (e.g., update basket)
    if ( window.jQuery ) {
      jQuery(document).ajaxComplete(function(){
        initQtyButtons();
      });
    }
  })();
  